import { useShouldShowSuggestedActionsLightbox } from '@ms/yammer-web-components/dist/firstRunExperience/hooks';
import type { FC } from 'react';
import React from 'react';

import SuggestedActionsLightbox from '../SuggestedActionsLightbox';

export const SuggestedActionsLightboxDialog: FC = () => {
  'use memo';

  const hasSuggestedActions = useShouldShowSuggestedActionsLightbox();

  if (hasSuggestedActions) {
    return <SuggestedActionsLightbox />;
  }

  return null;
};

export default SuggestedActionsLightboxDialog;
